<template>
  <div class="card">
    <div class="card-header text-center d-flex" :style="{
      backgroundColor:
        this.mission_banner.approval === 'Pending' ? '#ffc107' : 'black',
      padding: '10px',
      color: 'white',
    }">
      <h5 class="flex-grow-1">Banner</h5>
      <span v-if="this.mission_banner.approval === 'Pending'" class="float-right btn bg-secondary"><i
          class="fa fa-lock text-white"></i></span>
    </div>
    <div class="card-body">
      <div class="col-4">
        <div style="display: flex; flex-direction: column">
          <div style="display: flex; flex-direction: row; align-items: center">
            <img :src="mission_banner.image_url" style="
                width: 120px;
                height: 120px;
                object-fit: contain;
                border-radius: 10px;
                border: dashed 1px gray;
              " />
            <div v-if="!isApprover && this.mission_banner.approval !== 'Pending'"
              class="fileUpload bg-none text-left align-middle d-block">
              <div>
                <span class="media-text p-2">Select from Media Library (Max dimension 1200 x 800 px)</span>
              </div>
              <button @click="openGalleryModal('mission_banner')" aria-hidden="true" class="mx-2 p-2 border w-auto">
                Browse...
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="float-right">
        <button @click="bannerPreview" class="btn btn-light m-2">
          Preview
        </button>
        <button v-if="!isApprover && mission_banner.approval !== 'Pending'" @click="bannerDraft"
          class="btn btn-light m-2">
          Save Draft
        </button>
        <button v-if="!isApprover && mission_banner.approval !== 'Pending'" @click="bannerSubmit"
          class="btn btn-warning m-2">
          Submit For Approval
        </button>
        <button v-if="isApprover && mission_banner.approval === 'Pending'" data-bs-toggle="modal"
          data-bs-target="#approveModal" class="btn btn-warning m-2 approveModal"
          @click="openApprovalModal('mission_banner')">
          Approval
        </button>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header text-center d-flex" :style="{
      backgroundColor:
        this.mission_mission.approval === 'Pending' ? '#ffc107' : 'black',
      padding: '10px',
      color: 'white',
    }">
      <h5 class="flex-grow-1">Our Mission</h5>
      <span v-if="this.mission_mission.approval === 'Pending'" class="float-right btn bg-secondary"><i
          class="fa fa-lock text-white"></i></span>
    </div>

    <div class="card-body">
      <h5 class="fw-bold">Heading</h5>
      <textarea class="form-control border-dark mb-5" name="" id="" cols="10" rows="2" v-model="mission_mission.heading"
        :disabled="isApprover || mission_mission.approval === 'Pending'"></textarea>

      <h5 class="fw-bold">Title</h5>
      <textarea class="form-control border-dark mb-5" name="" id="" cols="10" rows="2" v-model="mission_mission.title"
        :disabled="isApprover || mission_mission.approval === 'Pending'"></textarea>

      <h5 class="fw-bold">Description</h5>
      <textarea class="form-control border-dark mb-5" name="" id="" cols="10" rows="2"
        v-model="mission_mission.description" :disabled="isApprover || mission_mission.approval === 'Pending'"></textarea>

      <div class="float-right">
        <button @click="missionPreview" class="btn btn-light m-2">
          Preview
        </button>
        <button v-if="!isApprover && mission_mission.approval !== 'Pending'" @click="missionDraft"
          class="btn btn-light m-2">
          Save Draft
        </button>
        <button v-if="!isApprover && mission_mission.approval !== 'Pending'" @click="missionSubmit"
          class="btn btn-warning m-2">
          Submit For Approval
        </button>
        <button v-if="isApprover && mission_mission.approval === 'Pending'" data-bs-toggle="modal"
          data-bs-target="#approveModal" class="btn btn-warning m-2 approveModal"
          @click="openApprovalModal('mission_mission')">
          Approval
        </button>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header text-center d-flex" :style="{
      backgroundColor:
        this.mission_vision.approval === 'Pending' ? '#ffc107' : 'black',
      padding: '10px',
      color: 'white',
    }">
      <h5 class="flex-grow-1">Our Vision</h5>
      <span v-if="this.mission_vision.approval === 'Pending'" class="float-right btn bg-secondary"><i
          class="fa fa-lock text-white"></i></span>
    </div>
    <div class="card-body">
      <div class="col-4">
        <div style="display: flex; flex-direction: column">
          <div style="display: flex; flex-direction: row; align-items: center">
            <img :src="mission_vision.image_url" style="
                width: 120px;
                height: 120px;
                object-fit: contain;
                border-radius: 10px;
                border: dashed 1px gray;
              " />
            <div v-if="!isApprover && this.mission_vision.approval !== 'Pending'"
              class="fileUpload bg-none text-left align-middle d-block">
              <div>
                <span class="media-text p-2">Select from Media Library (Max dimension 1200 x 800 px)</span>
              </div>
              <button @click="openGalleryModal('vision')" aria-hidden="true" class="mx-2 p-2 border w-auto">
                Browse...
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="float-right">
        <button @click="visionPreview" class="btn btn-light m-2">
          Preview
        </button>
        <button v-if="!isApprover && mission_vision.approval !== 'Pending'" @click="visionDraft"
          class="btn btn-light m-2">
          Save Draft
        </button>
        <button v-if="!isApprover && mission_vision.approval !== 'Pending'" @click="visionSubmit"
          class="btn btn-warning m-2">
          Submit For Approval
        </button>
        <button v-if="isApprover && mission_vision.approval === 'Pending'" data-bs-toggle="modal"
          data-bs-target="#approveModal" class="btn btn-warning m-2 approveModal"
          @click="openApprovalModal('mission_vision')">
          Approval
        </button>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header text-center d-flex" :style="{
      backgroundColor:
        this.mission_value.approval === 'Pending' ? '#ffc107' : 'black',
      padding: '10px',
      color: 'white',
    }">
      <h5 class="flex-grow-1">Our Values</h5>
      <span v-if="this.mission_value.approval === 'Pending'" class="float-right btn bg-secondary"><i
          class="fa fa-lock text-white"></i></span>
    </div>
    <div class="card-body">
      <h5 class="fw-bold">Heading</h5>
      <textarea class="form-control border-dark mb-5" name="" id="" cols="10" rows="2"
        v-model="mission_value.heading" :disabled="isApprover || mission_value.approval === 'Pending'"></textarea>

      <h5 class="fw-bold">Top Description</h5>
      <textarea class="form-control border-dark mb-5" name="" id="" cols="10" rows="2"
        v-model="mission_value.description" :disabled="isApprover || mission_value.approval === 'Pending'"></textarea>

      <div class="col-lg-12 row">
        <div class="col-lg-6 b-r-dark">
          <p>
            Only the text in the Value section will be editable. Images and
            Icons are fixed
          </p>
          <div class="mt-4 mb-3 values-img"></div>
        </div>
        <div class="col-lg-6 values">
          <div class="d-flex">
            <div class="col-lg-3">
              <h5 class="fw-bold">Serve</h5>
            </div>
            <div class="col-lg-9">
              <textarea class="form-control border-dark mb-5" name="" id="" cols="5" rows="2"
                v-model="serveValue" :disabled="isApprover || mission_value.approval === 'Pending'"></textarea>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-lg-3">
              <h5 class="fw-bold">Integrity</h5>
            </div>
            <div class="col-lg-9">
              <textarea class="form-control border-dark mb-5" name="" id="" cols="5" rows="2"
                v-model="integrityValue" :disabled="isApprover || mission_value.approval === 'Pending'"></textarea>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-lg-3">
              <h5 class="fw-bold">Inclusion</h5>
            </div>
            <div class="col-lg-9">
              <textarea class="form-control border-dark mb-5" name="" id="" cols="5" rows="2"
                v-model="inclusionValue" :disabled="isApprover || mission_value.approval === 'Pending'"></textarea>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-lg-3">
              <h5 class="fw-bold">Community</h5>
            </div>
            <div class="col-lg-9">
              <textarea class="form-control border-dark mb-5" name="" id="" cols="5" rows="2"
                v-model="communityValue" :disabled="isApprover || mission_value.approval === 'Pending'"></textarea>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-lg-3">
              <h5 class="fw-bold">Family</h5>
            </div>
            <div class="col-lg-9">
              <textarea class="form-control border-dark mb-5" name="" id="" cols="5" rows="2"
                v-model="familyValue" :disabled="isApprover || mission_value.approval === 'Pending'"></textarea>
            </div>
          </div>
        </div>
      </div>

      <h5 class="fw-bold">Bottom Description</h5>
      <textarea class="form-control border-dark mb-5" name="" id="" cols="10" rows="2"
        v-model="mission_value.bottom_description" :disabled="isApprover || mission_value.approval === 'Pending'"></textarea>

      <div class="float-right">
        <button @click="valuesPreview" class="btn btn-light m-2">
          Preview
        </button>
        <button v-if="!isApprover && mission_value.approval !== 'Pending'" @click="valuesDraft" class="btn btn-light m-2">
          Save Draft
        </button>
        <button v-if="!isApprover && mission_value.approval !== 'Pending'" @click="valuesSubmit"
          class="btn btn-warning m-2">
          Submit For Approval
        </button>
        <button v-if="isApprover && mission_value.approval === 'Pending'" data-bs-toggle="modal"
          data-bs-target="#approveModal" class="btn btn-warning m-2 approveModal"
          @click="openApprovalModal('mission_values')">
          Approval
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SmallButtonComponent from "@/components/SmallButtonComponent.vue";
import DropFile from "@/components/DropFile.vue";
import FileUploadComponent from "@/components/FileUploadComponent.vue";
import { getRequest, postRequest } from "@/services/RequestService";
import ImageComponent from "@/components/ImageComponent.vue";
import ApprovalComponent from "@/components/ApprovalComponent.vue";
import { checkUserRole } from "@/services/Auth.js";

export default {
  components: {
    SmallButtonComponent,
    DropFile,
    FileUploadComponent,
    ImageComponent,
    ApprovalComponent,
  },

  data() {
    return {
      mission_banner: [],
      mission_mission: [],
      mission_vision: [],
      mission_value: [],
      isApprover: false,
      datas: [],

      serveValue: "",
      integrityValue: "",
      inclusionValue: "",
      communityValue: "",
      familyValue: "",
    };
  },

  methods: {
    async loadMission() {
      try {
        let response = await getRequest("/about-us/create?section=5", true);

        if (response.data.success === false) {
          throw new Error("Error encountered. Please try again.");
        }
        this.mission_banner = response.data.data.mission_banner;
        this.mission_mission = response.data.data.mission_mission;
        this.mission_vision = response.data.data.mission_vision;
        this.mission_value = response.data.data.mission_value;

        this.mission_value.values.forEach((item) => {
          if (item.key === "Serve") {
            this.serveValue = item.value;
          } else if (item.key === "Integrity") {
            this.integrityValue = item.value;
          } else if (item.key === "Inclusion") {
            this.inclusionValue = item.value;
          } else if (item.key === "Community") {
            this.communityValue = item.value;
          } else if (item.key === "Family") {
            this.familyValue = item.value;
          }
        });
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    },

    openGalleryModal(section) {
      console.log("Open Gallery for:", section);

      document.getElementById("modal_id").value = section;

      var galleryModal = document.getElementById("galleryModal");
      galleryModal.classList.add("show");
      galleryModal.style.display = "block";

      this.$emit("mission", {
        banner: this.mission_banner,
        image: this.mission_vision,
      });
    },

    //Banner Section
    async bannerPreview() {
      if (this.mission_banner.approval == 'Pending' || (this.mission_banner.approval == 'Approved' && this.isApprover)) {
        window.open("/mission-vision?preview=1");
      } else {
        let postData = {
          image: this.mission_banner.gallery_id
            ? this.mission_banner.gallery_id
            : this.mission_banner.image_id,
          approval: false,
        };

        let response;
        if (this.mission_banner.approval === "Draft") {
          response = await postRequest(
            "/missions/banner/" + this.mission_banner.id,
            postData
          );
        } else {
          response = await postRequest("/missions/banner", postData);
        }

        if (response.data.success) {
          window.open("/mission-vision?preview=1", "_blank");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },
    bannerDraft() {
      this.bannerSubmission(this.mission_banner, 0);
    },
    bannerSubmit() {
      this.bannerSubmission(this.mission_banner, 1);
    },

    async bannerSubmission(data, approval) {
      try {
        let post_request = this._bannerRequest(data);
        post_request.approval = approval;

        let response;
        if (this.mission_banner.approval === "Draft") {
          response = await postRequest(
            "/missions/banner/" + this.mission_banner.id,
            post_request
          );
        } else {
          response = await postRequest("/missions/banner", post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _bannerRequest(data) {
      return {
        image: this.mission_banner.gallery_id
          ? this.mission_banner.gallery_id
          : this.mission_banner.image_id,
        status: 0,
      };
    },

    //Mission Description Section
    async missionPreview() {
      if (this.mission_mission.approval == 'Pending' || (this.mission_mission.approval == 'Approved' && this.isApprover)) {
        window.open("/mission-vision?preview=1");
      } else {
        let postData = {
          heading: this.mission_mission.heading,
          title: this.mission_mission.title,
          description: this.mission_mission.description,
          approval: false,
        };

        let response;
        if (this.mission_mission.approval === "Draft") {
          response = await postRequest(
            `/missions/description/` + this.mission_mission.id,
            postData
          );
        } else {
          response = await postRequest(`/missions/description`, postData);
        }

        if (response.data.success) {
          window.open("/mission-vision?preview=1", "_blank");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },
    missionDraft() {
      this.missionSubmission(this.mission_mission, 0);
    },
    missionSubmit() {
      this.missionSubmission(this.mission_mission, 1);
    },

    async missionSubmission(data, approval) {
      try {
        let post_request = this._missionRequest(data);
        post_request.approval = approval;

        let response;
        if (this.mission_mission.approval === "Draft") {
          response = await postRequest(
            `/missions/description/` + this.mission_mission.id,
            post_request
          );
        } else {
          response = await postRequest(`/missions/description`, post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _missionRequest(data) {
      return {
        heading: data.heading,
        title: data.title,
        description: data.description,
        status: 0,
      };
    },

    //Vision Section
    async visionPreview() {
      if (this.mission_vision.approval == 'Pending' || (this.mission_vision.approval == 'Approved' && this.isApprover)) {
        window.open("/mission-vision?preview=1");
      } else {
        let postData = {
          image: this.mission_vision.gallery_id
            ? this.mission_vision.gallery_id
            : this.mission_vision.image_id,
          approval: false,
        };

        let response;
        if (this.mission_vision.approval === "Draft") {
          response = await postRequest(
            "/missions/vision/" + this.mission_vision.id,
            postData
          );
        } else {
          response = await postRequest("/missions/vision", postData);
        }

        if (response.data.success) {
          window.open("/mission-vision?preview=1", "_blank");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },
    visionDraft() {
      this.visionSubmission(this.mission_vision, 0);
    },
    visionSubmit() {
      this.visionSubmission(this.mission_vision, 1);
    },

    async visionSubmission(data, approval) {
      try {
        let post_request = this._visionRequest(data);
        post_request.approval = approval;

        let response;
        if (this.mission_vision.approval === "Draft") {
          response = await postRequest(
            "/missions/vision/" + this.mission_vision.id,
            post_request
          );
        } else {
          response = await postRequest("/missions/vision", post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _visionRequest(data) {
      return {
        image: this.mission_vision.gallery_id
          ? this.mission_vision.gallery_id
          : this.mission_vision.image_id,
        status: 0,
      };
    },

    //Value Section
    async valuesPreview() {
      if (this.mission_value.approval == 'Pending' || (this.mission_value.approval == 'Approved' && this.isApprover)) {
        window.open("/mission-vision?preview=1");
      } else {
        let postData = {
          heading: this.mission_value.heading,
          description: this.mission_value.description,
          bottom_description: this.mission_value.bottom_description,
          values: [
            {
              serve: this.serveValue,
            },
            {
              integrity: this.integrityValue,
            },
            {
              inclusion: this.inclusionValue,
            },
            {
              community: this.communityValue,
            },
            {
              family: this.familyValue,
            },
          ],
          approval: false,
        };

        let response;
        if (this.mission_value.approval === "Draft") {
          response = await postRequest(
            `/missions/value/` + this.mission_value.id,
            postData
          );
        } else {
          response = await postRequest(`/missions/value`, postData);
        }

        if (response.data.success) {
          window.open("/mission-vision?preview=1", "_blank");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }
      }
    },
    valuesDraft() {
      this.valueSubmission(this.mission_value, 0);
    },
    valuesSubmit() {
      this.valueSubmission(this.mission_value, 1);
    },

    async valueSubmission(data, approval) {
      try {
        let post_request = this._valueRequest(data);
        post_request.approval = approval;

        let response;
        if (this.mission_value.approval === "Draft") {
          response = await postRequest(
            `/missions/value/` + this.mission_value.id,
            post_request
          );
        } else {
          response = await postRequest(`/missions/value`, post_request);
        }

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _valueRequest(data) {
      return {
        heading: data.heading,
        description: data.description,
        bottom_description: data.bottom_description,
        values: [
          {
            serve: this.serveValue,
          },
          {
            integrity: this.integrityValue,
          },
          {
            inclusion: this.inclusionValue,
          },
          {
            community: this.communityValue,
          },
          {
            family: this.familyValue,
          },
        ],
        status: 0,
      };
    },

    async checkUserRole() {
      this.isApprover = await checkUserRole();
    },

    openApprovalModal(modalName) {
      document.getElementById("data_id").value = modalName;

      this.$emit("mission_approval", {
        banner: this.mission_banner,
        mission: this.mission_mission,
        vision: this.mission_vision,
        value: this.mission_value,
      });
    },
  },

  async mounted() {
    this.checkUserRole();
    await this.loadMission();
  },
};
</script>

<style>
.values-img {
  height: 30rem;
  background-image: url("@/assets/images/admin/about-us/Value.svg");
  background-size: contain;
}

.values textarea {
  resize: none;
}
</style>
